import styled from '@emotion/styled';
import { TextArea } from '@workday/canvas-kit-react/text-area';
import { WcpStyles } from '@workday/wcp-tokens';
import React, { Ref } from 'react';

const StyledTextArea = styled(TextArea)({
  color: WcpStyles.color.text.default,
  backgroundColor: WcpStyles.color.bg.default,
  borderColor: `${WcpStyles.color.border.divider} !important`,
  '::placeholder': {
    color: WcpStyles.color.text.hint,
  },
  ':hover': {
    borderColor: `${WcpStyles.color.border.input.strong} !important`,
  },
  ':disabled': {
    backgroundColor: WcpStyles.color.bg.alt.softer,
    borderColor: WcpStyles.color.border.input.disabled,
  },
});

export const ThemedTextArea = React.forwardRef(
  ({ ...props }: React.ComponentProps<typeof TextArea>, ref: Ref<HTMLTextAreaElement>) => {
    return <StyledTextArea {...props} ref={ref} />;
  }
);
ThemedTextArea.displayName = 'ThemedTextArea';
